import React, { useState } from 'react';
import { Button, CircularProgress } from '@mui/material';
import RefreshIcon from '@mui/icons-material/Refresh';
import { toastHandler } from '../utils/toastHandler';
import { ExactDeliverySlot } from '../client/services';

interface CheckLateOrdersButtonProps {
  onCheckComplete?: (count: number) => void;
}

const CheckLateOrdersButton: React.FC<CheckLateOrdersButtonProps> = ({ onCheckComplete }) => {
  const [loading, setLoading] = useState(false);

  const handleCheckLateOrders = async () => {
    setLoading(true);

    try {
      // Call the find method with action parameter
      const response = await ExactDeliverySlot.find({
        query: { action: 'checkLateOrders' },
      });

      if (response && response.success) {
        toastHandler({
          message: response.message || 'Late order check completed',
          type: 'success',
        });

        if (onCheckComplete) {
          onCheckComplete(response.lateOrdersFound || 0);
        }
      }
    } catch (error: any) {
      console.error('Error checking for late orders:', error);
      toastHandler({
        message: error.message || 'Failed to check for late orders',
        type: 'error',
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Button
      variant="outlined"
      startIcon={loading ? <CircularProgress size={16} /> : <RefreshIcon />}
      onClick={handleCheckLateOrders}
      disabled={loading}
    >
      {loading ? 'Checking...' : 'Check Late Orders'}
    </Button>
  );
};

export default CheckLateOrdersButton;

